import React from 'react';
import Input from '../../../components/ui/Input';

const DurationSection = ({ formData, errors, onChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-bold text-foreground mb-6">Duração da Obra</h3>
      <div className="space-y-5">
        <Input
          label="Duração em Semanas"
          type="number"
          min="1"
          placeholder="Ex: 8"
          value={formData?.duracaoSemanas}
          onChange={(e) => onChange('duracaoSemanas', e?.target?.value)}
          error={errors?.duracaoSemanas}
          required
          description="Tempo estimado em semanas"
          className="text-base"
        />
        
        <Input
          label="Duração em Meses"
          type="number"
          min="1"
          placeholder="Ex: 2"
          value={formData?.duracaoMeses}
          onChange={(e) => onChange('duracaoMeses', e?.target?.value)}
          error={errors?.duracaoMeses}
          required
          description="Calculado automaticamente (1 mês ≈ 4.33 semanas)"
          className="text-base"
        />
        
        <div className="p-4 bg-muted/50 rounded-lg border border-border">
          <p className="text-sm text-muted-foreground leading-relaxed">
            <strong className="font-semibold">Dica:</strong> A duração em meses é calculada automaticamente ao preencher as semanas.
            Você pode ajustar manualmente se necessário.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DurationSection;